module.exports = __webpack_public_path__ + "static/media/24.0f035b61.jpg";